import { MENU_SCREEN } from "../menu.types";
import { getHeadingByScreen } from "../utils/getHeadingByScreen";

export const useMenuHeading = (screen: MENU_SCREEN) => getHeadingByScreen(screen);
